// extracted by mini-css-extract-plugin
export default {"navigation-container":"NPgIM_navigation-container","header-container":"P4Udn_header-container","navi-icon":"Q_7o4_navi-icon","header-title":"lLijP_header-title"};